import { Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { EllipsisContainer } from 'src/components/EllipsisContainer/EllipsisContainer';
import {
    MainContainer,
    MainEntityListItemText,
    MasterDetailsAsideItem,
    SecondaryContainer,
    SecondaryEntityListItemText,
} from 'src/components/MasterDetailsPage/MasterDetailsAsideItem';
import { EntityLinks } from 'src/core/router/EntityLinks';
import { CollateralDto } from 'src/generated-api-client';
import { collateralTypesMap } from 'src/pages/CollateralsPage/CollateralTypesMap';
import { SettingsStore } from 'src/stores/SettingsStore/SettingsStore';
import { NumberHelper } from 'src/utils/NumberHelper';
import styled from 'styled-components';

type CollateralListItemProps = { item: CollateralDto };

export const CollateralListItem = observer(
    ({ item }: CollateralListItemProps) => {
        const { t, i18n } = useTranslation();
        const currencyMnemonic = SettingsStore.currencyMnemonic as string;

        const collateralType = item.type
            ? t(
                  `data:collateralType.${
                      collateralTypesMap[item.type]?.title || item.type
                  }`,
              )
            : '';

        return (
            <MasterDetailsAsideItem
                to={EntityLinks.collaterals.itemDetails(item.id)}
            >
                <MainContainer>
                    <Tooltip title={item.description}>
                        <EllipsisContainer>
                            <MainEntityListItemText
                                className="strong-text"
                                data-testid="registration-number"
                            >
                                {item.registrationNumber}
                            </MainEntityListItemText>
                        </EllipsisContainer>
                    </Tooltip>
                    <SmallEntityListItemText data-testid="collateral-type">
                        {collateralType}
                    </SmallEntityListItemText>
                </MainContainer>
                <SecondaryContainer>
                    <SecondaryEntityListItemText>
                        <span className="strong-text" data-testid="value">
                            {NumberHelper.currencyFormatter(item?.value || 0, {
                                currencyMnemonic,
                                locale: i18n.language,
                            })}
                        </span>
                    </SecondaryEntityListItemText>
                </SecondaryContainer>
            </MasterDetailsAsideItem>
        );
    },
);

const SmallEntityListItemText = styled.span`
    display: block;
    font-size: 0.9rem;
    line-height: 120%;
    letter-spacing: -0.1px;
    color: var(--form-secondary-text-color);
`;
